export default function ConditionallyRender({when,children}) {

    if(when){
        return children
    }
  return null
}
